var loadMessgeListInterval;

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import MessageBoxList from './message_box_list';
import Loader from '../loader';
import MessageSendForm from './message_send_form';
import ModalConfirm from '../modal/modal_confirm';
import ModalAlert from '../modal/modal_alert';

export default createReactClass({
  displayName: 'Root',
  getInitialState() {
    return {
      circle: {},
      loading: true,
      isPreviousLoading: false,
      isDisplayPreviousBtn: false,
      page: 1,
      messages: [],
      updatedMessages: [],
      isFirstLoad: true,
      maxMessageId: 0,
      calledAt: '',
      unreadMessageCount: 0,
      messageCount: 0,
      isSubmit: false,
      isBalloonDisp: PropTypes.bool,
      isCompany: this.props.isCompany ? this.props.isCompany : false,
      messageListPadding: 0,
    };
  },
  loadMessageListFromServer() {
    $.ajax({
      url: '/api/message/circle',
      dataType: 'json',
      cache: false,
      data: {
        circle_id: this.props.circle.id,
        max_message_id: this.state.maxMessageId,
        prev_called_at: this.state.calledAt,
      },
    })
      .done(
        function (data) {
          // success
          var updatedMessages = {};
          data.updatedMessages.forEach(function (message) {
            updatedMessages[message.id] = message;
          });
          var base = this.state.messages.map(old =>
            updatedMessages[old.id] || old
          );

          var seen = new Set(base.map(m => m.id));
          var newOnes = (data.messages || []).filter(m => !seen.has(m.id));

          var merged = [...base, ...newOnes];

          var maxMessageId = data.maxMessageId
            ? data.maxMessageId
            : this.state.maxMessageId;
          if (
            data.circle.charge_plan_type > 0 &&
            data.messageCount > 100 &&
            this.state.page == 1
          ) {
            this.setState({
              isDisplayPreviousBtn: true,
            });
          }
          this.setState(
            {
              loading: false,
              circle: data.circle,
              messages: merged,
              maxMessageId: maxMessageId,
              calledAt: data.calledAt,
              messageCount: data.messageCount,
              unreadMessageCount: data.unreadMessageCount,
            },
            function () {
              if (this.state.isFirstLoad) {
                $('.flexContainer').innerHeight(window.innerHeight);
                this.scrollToBottom();
                this.setState({
                  isFirstLoad: false,
                });
              }

              if (this.state.isSubmit) {
                $('.containerMessage').height('');
                this.setState({
                  isSubmit: false,
                });
                this.scrollToBottom();
              }
            }
          );
        }.bind(this)
      )
      .fail(
        function () {
          // error
        }.bind(this)
      );
  },
  componentDidMount() {
    this.loadMessageListFromServer();
    $(window).on(
      'focus',
      function () {
        this.loadMessageListFromServer();
      }.bind(this)
    );
    loadMessgeListInterval = setInterval(this.loadMessageListFromServer, 8000);
  },
  componentDidUpdate(prevProps, prevState) {
    var ancLatestMessage = this.ancLatestMessage;
    if (
      this.state.loading ||
      prevState.messages[prevState.messages.length - 1] === undefined ||
      this.state.messages[prevState.messages.length - 1] === undefined ||
      prevState.messages[prevState.messages.length - 1].body !==
        this.state.messages[this.state.messages.length - 1].body
    ) {
      if (window.innerWidth > 767) {
        // PC
        $('.block-messageList').scrollTop(ancLatestMessage.offsetTop);
      } else {
        // スマホ
        $('html, body').scrollTop(ancLatestMessage.offsetTop);
      }
    }
  },
  pauseLoading() {
    clearInterval(loadMessgeListInterval);
  },
  startLoading() {
    loadMessgeListInterval = setInterval(this.loadMessageListFromServer, 8000);
  },
  handleMessageSubmit: function (message) {
    clearInterval(loadMessgeListInterval);
    this.setState({
      loading: true,
      isSubmit: true,
    });
    $.ajax({
      url: '/api/message/circle_all_send',
      type: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        body: message['body'],
        circle_id: this.props.circle.id,
        parent_message_id: message['parent_message_id'],
      },
      cache: false,
      success: function () {
        this.loadMessageListFromServer();
        loadMessgeListInterval = setInterval(
          this.loadMessageListFromServer,
          8000
        );
      }.bind(this),
      error: function () {
        this.loadMessageListFromServer();
        loadMessgeListInterval = setInterval(
          this.loadMessageListFromServer,
          8000
        );
      }.bind(this),
    });
  },
  handleLoadPreviousMessage() {
    var page = this.state.page;
    page++;
    if (this.state.messageCount < 100 * (page - 1)) {
      this.setState({
        isDisplayPreviousBtn: false,
      });
      return false;
    }

    this.setState({
      isPreviousLoading: true,
    });

    $.ajax({
      url: '/api/message/circle',
      dataType: 'json',
      cache: false,
      data: {
        circle_id: this.props.circle.id,
        page: page,
        max_message_id: 0,
        prev_called_at: '',
      },
    })
      .done(
        function (data) {
          // success
          // var isDisplayPreviousBtn = false;
          var messages = data.messages.concat(this.state.messages);
          this.setState({
            isPreviousLoading: false,
            messages: messages,
            page: page,
          });
        }.bind(this)
      )
      .fail(
        function () {
          // error
        }.bind(this)
      );
  },
  setFile: function (file) {
    this.setState({
      file: file,
    });
  },
  openModal: function () {
    this.modalConfirm.openModal();
  },
  handlePhotoSubmit() {
    clearInterval(loadMessgeListInterval);
    this.setState({
      loading: true,
      isSubmit: true,
    });
    var formData = new FormData();
    formData.append('file', this.state.file);
    formData.append('circle_id', this.props.circle.id);
    $.ajax({
      type: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      url: '/api/message/circle_all_send',
      cache: false,
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          // success
          // prevTargetScrollHeight = undefined;
          this.loadMessageListFromServer();
          loadMessgeListInterval = setInterval(
            this.loadMessageListFromServer,
            8000
          );
        }.bind(this)
      )
      .fail(
        function () {
          // error
          this.modalAlert.openModal();
          this.setState({
            loading: false,
          });
          loadMessgeListInterval = setInterval(
            this.loadMessageListFromServer,
            8000
          );
        }.bind(this)
      );
  },
  scrollToBottom() {
    var target = $('.block-messageList');
    if (window.innerWidth > 767) {
      $('html, body').scrollTop(target.height());
    } else {
      $('.containerMessage').scrollTop(target.height());
    }
  },
  setMessageListPadding(messageListPadding) {
    this.setState(
      {
        messageListPadding,
      },
      () => {
        this.scrollToBottom();
      }
    );
  },
  render() {
    var currentUserId = this.props.currentUser.id;
    // var numOfMembers = this.props.numOfMembers;

    // var numOfMembersDisp = "  (" + numOfMembers + ")";
    // var circleName = this.props.circle.name;
    // var myCircleLink = "/circle/" + this.props.circle.id;

    // var unreadBadge = "";
    // if (this.state.unreadMessageCount > 0) {
    //   unreadBadge = (
    //     <span className="badge g-color-white g-bg-red g-rounded-50x">
    //       {this.state.unreadMessageCount}
    //     </span>
    //   );
    // }

    let num = 0;
    let havePictureLength = this.state.messages.filter(
      (v) => v.picture_medium !== null && v.picture_medium !== undefined
    ).length;
    var messageBoxList = this.state.messages.map(function (message) {
      if (message.picture_medium !== null) num++;
      return (
        <MessageBoxList
          message={message}
          currentUserId={currentUserId}
          isLastPictureMessage={
            message.picture_medium !== null && havePictureLength === num
          }
          key={message.id}
        />
      );
    });

    // var handlePreviousBtn = "";
    // if (this.state.isDisplayPreviousBtn) {
    //   handlePreviousBtn = (
    //     <div style={{ textAlign: "center" }}>
    //       <a className="small" onClick={this.handleLoadPreviousMessage}>
    //         以前のメッセージを表示
    //       </a>
    //       <Loader isActive={this.state.isPreviousLoading} />
    //     </div>
    //   );
    // }

    // var messageListAll = '';
    // if (window.innerWidth > 767) {  // PC
    //   messageListAll = <div>
    //     <div id="block-message-container" className="containerMessage">
    //       <div className="block-message">
    //         <div className="block-messageList" ref="blockMessageList">
    //           <div className="block-messageListInner" ref="blockMessageListInner">
    //             {messageBoxList}
    //             <Loader isActive={this.state.loading} />
    //             <div id="ancLatestMessage" ref="ancLatestMessage"></div>
    //           </div>
    //           <MessageSendForm
    //             onMessageSubmit={this.handleMessageSubmit}
    //             setFile = {this.setFile}
    //             openModal = {this.openModal}
    //             messageGroupId={this.props.messageGroupId}
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </div>;
    // } else {  // スマホ
    //   messageListAll = <div id="block-message-container" className="containerMessage flexMessage">
    //     <div className="block-messageList" ref="blockMessageList">
    //       {messageBoxList}
    //     </div>

    //     <Loader isActive={this.state.loading} />
    //     <div id="ancLatestMessage" ref="ancLatestMessage"></div>
    //   </div>;
    // }

    var messageListAll = (
      <div
        className={`${
          window.innerWidth > 767 ? 'bg-gray h-main100vh' : ''
        } pb-5`}
        style={{ paddingBottom: this.state.messageListPadding }}
      >
        <div className="block-messageList container col-md-8 col-lg-6">
          <ul className="list-unstyled mb-2 pt-3">{messageBoxList}</ul>
          <Loader isActive={this.state.loading} />
          <div
            id="ancLatestMessage"
            ref={(c) => {
              this.ancLatestMessage = c;
            }}
          />
        </div>
      </div>
    );

    var reactRoot = '';

    if (window.innerWidth > 767) {
      // PC
      reactRoot = (
        <div className="react-root">
          <div>
            {messageListAll}
            <MessageSendForm
              onMessageSubmit={this.handleMessageSubmit}
              loadMessageListFromServer={this.loadMessageListFromServer}
              pauseLoading={this.pauseLoading}
              startLoading={this.startLoading}
              setFile={this.setFile}
              setMessageListPadding={this.setMessageListPadding}
              openModal={this.openModal}
              messageGroupId={this.props.messageGroupId}
            />
            <ModalConfirm
              ref={(c) => {
                this.modalConfirm = c;
              }}
              title="画像の送信"
              content="よろしいですか？"
              approveFunc={this.handlePhotoSubmit}
            />
            <ModalAlert
              ref={(c) => {
                this.modalAlert = c;
              }}
              title="画像の送信"
              content="画像の送信に失敗しました。"
            />
          </div>
        </div>
      );
    } else {
      // スマホ
      reactRoot = (
        <div className="reactRoot">
          <div className="bg-gray h-main100vh">
            {messageListAll}
            <MessageSendForm
              onMessageSubmit={this.handleMessageSubmit}
              loadMessageListFromServer={this.loadMessageListFromServer}
              pauseLoading={this.pauseLoading}
              startLoading={this.startLoading}
              setFile={this.setFile}
              setMessageListPadding={this.setMessageListPadding}
              openModal={this.openModal}
              messageGroupId={this.props.messageGroupId}
            />
            <ModalConfirm
              ref={(c) => {
                this.modalConfirm = c;
              }}
              title="画像の送信"
              content="よろしいですか？"
              approveFunc={this.handlePhotoSubmit}
            />
            <ModalAlert
              ref={(c) => {
                this.modalAlert = c;
              }}
              title="画像の送信"
              content="画像の送信に失敗しました。"
            />
          </div>
        </div>
      );
    }

    return reactRoot;
  },
});

// var prevTargetScrollHeight;
